import React from 'react';
import NotFoundPageContainer from '../../containers/not-found.container';

const NotFoundPage: React.FC = () => {
  return <NotFoundPageContainer />;
};

export default NotFoundPage;
